import React, { type PropsWithChildren } from "react";

import styles from "./AuthLayout.module.css";

type AuthLayoutProps = PropsWithChildren;

const AuthLayout = ({ children }: AuthLayoutProps) => {
	return (
		<div className={styles.root}>
			<div className={styles.content}>{children}</div>
		</div>
	);
};

export default AuthLayout;
